import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IStatistics } from '@/Module/Auth/Model/DataModel';
import { AuthService } from '@/Module/Auth/Service';

export const getStatisticsAction = createAsyncThunk<IStatistics>('Auth/getStatistics', async (_, { signal }) => {
  return AuthService.getStatistics(signal).then(({ data: { data } }) => data);
});
